import React, { useState, Fragment, Component } from 'react'
import Shimmer from "react-shimmer-effect";
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle,
    Button, Table, Label
} from "reactstrap"
import { Link, useHistory, useParams } from "react-router-dom"
import { withRouter } from "react-router";

import apiResponse from '../../../../services/apiResponse'
import PegawaiSideBar from "../../GlobalComponents/PegawaiSidebar";
import DetailBloc from './Blocs/DetailBloc'
import moment from 'moment';

class IndexView extends Component {

    detailBloc = new DetailBloc()

    constructor(props) {
        super(props)
        this.state = {
          document: null
        }
    }

    dateParse = (input) =>{
        let res = "-";
        if (input != "" && input != null){
          res = moment(input).format('DD/MM/YYYY')
        }
        return res;
    }

    componentDidMount() {
        this.detailBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        this.setState({
                            detail: response,
                            document_skp: response.document_skp,
                            document_pak: response.document_pak
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        const queryParams = new URLSearchParams(this.props.location.search)
        this.detailBloc.fetchDetail({uuid: queryParams.get('uuid') })
    }

    componentWillUnmount(){
      this.detailBloc.detailChannel?.unsubscribe()
    }

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">
                            <PegawaiSideBar active="riwayat_angkakredit" />
                            <Card className="pegawai-rightbar">
                                <CardBody>
                                    <CardTitle>Detail Pengajuan Angka Kredit</CardTitle>
                                    <hr />
                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Nama
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.employee_name !== "" ? this.state.detail.employee_name : '-'}</>
                                                : <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            NIP
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.employee_nip !== "" ? this.state.detail.employee_nip : '-'}</>
                                                : <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Tipe Angka Kredit
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.credit_number_type_name !== "" ? this.state.detail.credit_number_type_name : '-'}</>
                                                : <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Angka Kredit
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.credit_number_value !== "" ? this.state.detail.credit_number_value : '-'}</>
                                                : <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Periode
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.credit_number_period !== "" ? this.state.detail.credit_number_period : '-'}</>
                                                : <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <Label className="col-md-3 col-form-label">File Surat Keterangan SKP</Label>
                                        <Col md="6">
                                            {
                                                this.state.detail ?
                                                    <>
                                                        {this.state.document_skp !== null ?  
                                                            <a target={"_blank"} className="btn btn-sm btn-success" href={this.state.document_skp?.documents_path}>
                                                                Download <i className="fa fa-download ms-1"></i>
                                                            </a>
                                                        : '-'}
                                                    </>
                                                :
                                                    <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <Label className="col-md-3 col-form-label">File Surat Keterangan PAK</Label>
                                        <Col md="6">
                                            {
                                                this.state.detail ?
                                                    <>
                                                        {this.state.document_pak !== null ?  
                                                            <a target={"_blank"} className="btn btn-sm btn-success" href={this.state.document_pak?.documents_path}>
                                                                Download <i className="fa fa-download ms-1"></i>
                                                            </a>
                                                        : '-'}
                                                    </>
                                                :
                                                    <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Status
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>
                                                        {
                                                            this.state.detail.credit_number_status_name !== "" ? 
                                                                <label className={`badge rounded-pill ${this.state.detail.credit_number_status_class} font-size-12`}>{this.state.detail.credit_number_status_name}</label>
                                                            : '-'
                                                        }
                                                    </>
                                                : <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                            {
                                (this.state.detail && this.state.detail.credit_number_status == 2) ?
                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Alasan Penolakan
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>
                                                        {
                                                            this.state.detail.credit_number_approval_desc !== "" ? 
                                                                this.state.detail.credit_number_approval_desc
                                                            : '-'
                                                        }
                                                    </>
                                                : <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    :''
                            }
                                    <hr />
                                    
                                    <Row className="mb-3">
                                        <Col md="3"></Col>
                                        <Col md="9">
                                            <Link to="/kepegawaian/home.html?riwayat_angkakredit" className="waves-effect">
                                                <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                            </Link>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </Fragment>
        )
    }
}

//export default IndexView
export default withRouter(IndexView);